import { startTransition, useEffect, useState } from "react";

import BrowseSearchBar from "@/components/dataBrowse/browseSearchBar";
import { useDebouncedFunction } from "@/hooks/useDebouncedQueryParams";
import { DEBOUNCE_DELAY } from "@/utils";

type BufferedSearchInputProps = {
  value: string;
  onCommit: (value: string) => void;
  placeholder: string;
  className: string;
  inputId?: string;
  inputName?: string;
};

export default function BufferedSearchInput({
  value,
  onCommit,
  placeholder,
  className,
  inputId,
  inputName,
}: BufferedSearchInputProps) {
  const [draft, setDraft] = useState(value);
  const debouncedCommit = useDebouncedFunction((nextValue: string) => {
    startTransition(() => {
      onCommit(nextValue);
    });
  }, DEBOUNCE_DELAY);

  useEffect(() => {
    setDraft(value);
  }, [value]);

  return (
    <BrowseSearchBar
      searchQuery={draft}
      inputId={inputId}
      inputName={inputName}
      placeholder={placeholder}
      showAdvancedSearchButton={false}
      containerClassName="relative w-full"
      inputClassName={className}
      onSearchChange={(nextValue) => {
        setDraft(nextValue);
        debouncedCommit(nextValue);
      }}
      onClearSearch={() => {
        setDraft("");
        startTransition(() => {
          onCommit("");
        });
      }}
    />
  );
}
